<template>
  <div class="skin-toolbox">
      <div class="panel-body">
          <h4>主题颜色</h4>
          <NavBarBox :theme="theme" @onChange="onChangeTheme"></NavBarBox>
      </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import NavBarBox from './NavBarBox'
import clickOutside from 'element-ui/src/utils/clickoutside'

export default {
  directives: { clickOutside },
  components: { NavBarBox },
  data() {
    return {
      collapsed: true,
      activeName: 'navbar'
    }
  },
  mounted() {
  },
  computed: {
    ...mapGetters([
      'theme'
    ])
  },
  methods: {
    toggleSkinToolbox() {
      this.collapsed = !this.collapsed
    },
    onChangeTheme(val) {
      this.$store.commit('SET_THEME', val)
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.panel-icon > i{
  font-size: 24px !important;
}
</style>




// WEBPACK FOOTER //
// src/views/layout/components/SkinToolbox/index.vue